// extracted by mini-css-extract-plugin
export var announcementBar = "styles-module--announcementBar--GSRGF";
export var container = "styles-module--container--+exoC";
export var fadeIn = "styles-module--fadeIn--WhAxB";
export var fadeInAndMoveUp = "styles-module--fadeInAndMoveUp--RlIpW";
export var scaleUp = "styles-module--scaleUp--Q4O6Y";
export var slideIn = "styles-module--slideIn--IgBdG";
export var textContainer = "styles-module--textContainer--eduBW";